module.exports = __webpack_public_path__ + "static/media/YM46_9.cd64f62d.jpg";